import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import Home from "../domains/pages/Home";

interface Props {
  children: React.ReactNode;
}
const ProtectedRoute = ({ children }: Props) => {
  const [cookies] = useCookies(["apiKey"]);
  const navigate = useNavigate();
  const cookiesToken = cookies.apiKey;
  if (!cookiesToken) navigate("/");

  return cookiesToken ? <>{children} </> : <Home />;
};

export default ProtectedRoute;
